module.exports = __webpack_public_path__ + "img/darna.97c9aadb.jpg";